import {
  RUNTIME_FORM_DATA_ENDPOINT,
  RUNTIME_FORM_ENDPOINT,
} from "../constants/endpoints";
import { ResponseProps, request } from "./request";
import axios from "axios";

export const fetchRuntimeFormDetails = async (
  id: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem("gatewayURL")}${RUNTIME_FORM_ENDPOINT}/${id}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false };
};

export const fetchRuntimeFormData = async (
  id: string,
  page: number,
  size: number
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${RUNTIME_FORM_DATA_ENDPOINT}?formId=${id}&page=${page}&size=${size}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const fetchDesigntimeFormDetails = async (
  id: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem("gatewayURL")}${RUNTIME_FORM_ENDPOINT}/${id}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false };
};

export const filterRuntimeFormData = async (
  id: string,
  key: string,
  value: any
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${RUNTIME_FORM_DATA_ENDPOINT}?formId=${id}&filter=formData.${key}:${value}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const postRuntimeFormData = async (body: {
  formId: string;
  id?: string;
  formData: object;
}): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: ResponseProps = (await request.post(
    `${sessionStorage.getItem("gatewayURL")}${RUNTIME_FORM_DATA_ENDPOINT}`,
    body
  )) as ResponseProps;

  if (r.success) {
    return { success: r.success, data: r.data, message: r.message };
  }

  return { success: false, data: r.data, message: r.message };
};

export const filterRuntimeFormDataWithId = async (
  formId: string,
  id: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${RUNTIME_FORM_DATA_ENDPOINT}/${formId}?id=${id}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const DeleteRuntimeFormData = async (
  formId: string,
  id: string
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.delete(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${RUNTIME_FORM_DATA_ENDPOINT}/${formId}?id=${id}`
  );

  if (r.success) {
    return { success: r.success, data: r?.data, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};

export const patchFormData = async (bodyPayload: {
  formId: string;
  id: string;
  formData: any;
}): Promise<{ success: boolean; data?: any; message?: string }> => {
  try {
    const response = await axios.patch(
      `${sessionStorage.getItem("gatewayURL")}${RUNTIME_FORM_DATA_ENDPOINT}`,
      bodyPayload, // The data should be the second argument
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("react-token")}`,
        },
      }
    );

    const { success, data, message } = response.data;

    return { success, data, message };
  } catch (error) {
    return { success: false, message: `${error}`, data: null };
  }
};

export const multiFilterRuntimeFormData = async (
  id: string,
  key: string,
  value: any,
  key1: string,
  value1: any
): Promise<{ success: boolean; data?: any; message?: string }> => {
  const r: any = await request.get(
    `${sessionStorage.getItem(
      "gatewayURL"
    )}${RUNTIME_FORM_DATA_ENDPOINT}?formId=${id}&filter=formData.${key}:${value},formData.${key1}:${value1}`
  );

  if (r.success) {
    const form = r.data;
    return { success: r.success, data: form, message: r.message };
  }

  return { success: false, data: null, message: r.message };
};
